import { Navigate } from "react-router-dom-v5-compat";

import { getMegaraxPath } from "@megaron/megarax-uri";

export const MyThreadsRedirect = () => {
  return (
    <Navigate
      to={getMegaraxPath.uri("megarax://invoices/threads", {
        filters: {
          sort: {
            field: "invitedAt",
            order: "ASC",
          },
          status: ["open"],
          groupFilter: "mine",
          isMine: "true",
        },
      })}
      replace
    />
  );
};
